// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IfPZL","index":"styles_index__SkNGu"};